import { render, staticRenderFns } from "./CompletedCategoriesModal.vue?vue&type=template&id=c951ea58&scoped=true&"
import script from "./CompletedCategoriesModal.vue?vue&type=script&lang=js&"
export * from "./CompletedCategoriesModal.vue?vue&type=script&lang=js&"
import style0 from "./CompletedCategoriesModal.vue?vue&type=style&index=0&id=c951ea58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c951ea58",
  null
  
)

export default component.exports